import { ThemeProvider } from "@mui/material";
import HOC from "../../../components/HOC";
import PageTemplate from "../../../components/common/particles.jsx/PageTemplate";
import MedicalRecordList from "../../../components/screen/patientCare/medicalRecord/MedicalRecordList";
import { theme } from "../../../components/constants/muiTheme";

const MedicalRecordListPage = () => {
  return (
    <PageTemplate
      header="Patient Medical Record"
      mainComponent={
        <ThemeProvider theme={theme}>
          <MedicalRecordList />
        </ThemeProvider>
      }
      pageRole={17}
    />
  );
};

export default HOC(MedicalRecordListPage);
